module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-margin",
    attrs: {
      "uk-margin": ""
    }
  }, [_c('div', {
    attrs: {
      "uk-form-custom": "target: true"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.select
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "uk-input uk-form-width-medium",
    attrs: {
      "type": "text",
      "placeholder": "Kies Afbeeldingen",
      "disabled": ""
    }
  })])]), _vm._v(" "), _vm._l((_vm.files), function(f, i) {
    return (_vm.loaded[0 + i] != 100) ? _c('div', [_c('p', {
      staticClass: "uk-text-muted"
    }, [_vm._v(_vm._s(f.name))]), _vm._v(" "), _c('progress', {
      staticClass: "uk-progress",
      attrs: {
        "id": "js-progressbar",
        "max": "100"
      },
      domProps: {
        "value": _vm.loaded[0 + i]
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.URLS), function(img, i) {
    return (_vm.showForm) ? _c('div', {
      staticClass: "uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin",
      attrs: {
        "uk-grid": ""
      }
    }, [_c('div', {
      staticClass: "uk-card-media-left uk-cover-container"
    }, [_c('img', {
      attrs: {
        "src": img.url,
        "alt": "",
        "uk-cover": ""
      }
    }), _vm._v(" "), _c('canvas', {
      attrs: {
        "width": "600",
        "height": "400"
      }
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "uk-card-body"
    }, [_c('h3', {
      staticClass: "uk-card-title"
    }, [_vm._v("Afbeelding Info")]), _vm._v(" "), _c('form', [_c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Titel")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.title),
        expression: "img.title"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "title",
        "type": "text",
        "palceholder": "title"
      },
      domProps: {
        "value": (img.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Alt")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.alt),
        expression: "img.alt"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "alt",
        "type": "text",
        "palceholder": "alt"
      },
      domProps: {
        "value": (img.alt)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "alt", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Caption")]), _c('br'), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.caption),
        expression: "img.caption"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "caption",
        "type": "text",
        "palceholder": "caption"
      },
      domProps: {
        "value": (img.caption)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "caption", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('label', {
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Beschrijving")]), _c('br'), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (img.description),
        expression: "img.description"
      }],
      staticClass: "uk-input",
      attrs: {
        "id": "title",
        "name": "description",
        "type": "text",
        "palceholder": "Beschrijving"
      },
      domProps: {
        "value": (img.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(img, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "uk-margin"
    }, [_c('button', {
      staticClass: "uk-button uk-button-primary uk-align-left",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveInfo(i)
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), (_vm.status[i]) ? _c('p', [_vm._v(_vm._s(_vm.status[i]))]) : _vm._e()])])])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c8970a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/MEDIA/ImageUploader.vue
// module id = 509
// module chunks = 1